  import himaparasa from "../Assets/himaparasa.jpg";

  export const profile = {
    name: "Hima Varshini Parasa",
    titles: ["Software Engineering", "Cloud Computing", "AI/ML Systems"],
    bio: [
      "I build scalable systems with a healthy respect for distributed complexity.",
      "My work spans backend services, cloud-native design, and intelligent automation - optimized for reliability and performance.",
      "I enjoy solving problems that don’t have obvious answers both in my work and on long hikes, behind a camera, with music playing, somewhere between the mountains, the beach, and a rainy sky."
    ],
    image: himaparasa,
    social: {
      email: "himaparasa19@gmail.com",
      linkedin: "https://www.linkedin.com/in/hparasa/",
      github: "https://github.com/hparasa",
      leetcode: "https://leetcode.com/u/hparasa/"
    },
  };
